import animations from "../../animations/animations";
import { BREAKPOINTS } from "../../styles/variables/breakpoints";

const cubeIntroductionAnimation = ({ cube, scene, mm, markers }) => {
  const section = "introduction";
  const target = document.getElementById(section);

  mm.add(`(min-width: ${BREAKPOINTS.sm}px)`, context => {
    animations.set(cube.scale, { x: 0.5, y: 0.5, z: 0.5 });
  });

  mm.add(`(max-width: ${BREAKPOINTS.sm - 1}px)`, context => {
    animations.set(cube.scale, { x: 4, y: 4, z: 4 });
    animations.set(cube.rotation, { x: 0, y: -Math.PI / 2 });
  });

  const tl = animations.timeline({
    scrollTrigger: {
      id: section,
      trigger: target,
      markers: markers,
      start: "top top",
      end: "bottom bottom",
      scrub: true,
      invalidateOnRefresh: true,
    },
  });
  mm.add(`(min-width: ${BREAKPOINTS.sm}px)`, context => {
    tl.to(
      cube.rotation,
      {
        x: `+=${Math.PI * 2}`,
        y: `+=${Math.PI * 2}`,
        ease: "power1.inOut",
      },
      0
    )
      .to(
        cube.scale,
        {
          x: 6,
          y: 6,
          z: 6,
          ease: "power1.inOut",
        },
        0
      )
      .to(scene.background, {
        r: 1,
        g: 1,
        b: 1,
        duration: 2,
        ease: "power1.inOut",
      });
  });

  return tl;
};

const cubeArticlesAnimation = ({ cube, mm, markers }) => {
  const section = "component--articles-section";
  const target = document.getElementById(section);

  const tl = animations
    .timeline({
      scrollTrigger: {
        id: section,
        trigger: target,
        markers: markers,
        start: "top top",
        end: "+=800",
        scrub: true,
        invalidateOnRefresh: true,
      },
    })
    .to(
      cube.scale,
      {
        x: () => cube.scale.x - 2,
        y: () => cube.scale.y - 2,
        z: () => cube.scale.z - 2,
      },
      0
    );

  mm.add(`(min-width: ${BREAKPOINTS.sm}px)`, context => {
    tl.to(cube.rotation, {
      x: () => cube.rotation.x + Math.PI,
      ease: "power1.inOut",
    });
  });
  mm.add(`(max-width: ${BREAKPOINTS.sm - 1}px)`, context => {
    tl.to(cube.rotation, {
      y: () => cube.rotation.x + Math.PI / 2,
      ease: "power1.inOut",
    });
  });

  tl.to(cube.scale, {
    x: () => cube.scale.x + 2,
    y: () => cube.scale.y + 2,
    z: () => cube.scale.z + 2,
  });

  return tl;
};

const cubeProductsAnimations = ({ cube, mm, markers }) => {
  const section = "component--products-section";
  const target = document.getElementById(section);

  const tl = animations
    .timeline({
      scrollTrigger: {
        id: section,
        trigger: target,
        markers: markers,
        start: "top top",
        end: "+=800",
        scrub: true,
        invalidateOnRefresh: true,
      },
    })
    .to(cube.scale, {
      x: () => cube.scale.x - 2,
      y: () => cube.scale.y - 2,
      z: () => cube.scale.z - 2,
    });
  mm.add(`(min-width: ${BREAKPOINTS.sm}px)`, context => {
    tl.to(cube.rotation, {
      x: () => cube.rotation.x - Math.PI * 1.5,
      ease: "power1.inOut",
    });
  });
  mm.add(`(max-width: ${BREAKPOINTS.sm - 1}px)`, context => {
    tl.to(cube.rotation, {
      y: () => cube.rotation.x + Math.PI * 2,
      ease: "power1.inOut",
    });
  });
  tl.to(cube.scale, {
    x: () => cube.scale.x + 2,
    y: () => cube.scale.y + 2,
    z: () => cube.scale.z + 2,
  });
  return tl;
};

const cubeStreamAnimations = ({ cube, mm, markers }) => {
  const section = "component--stream-section";
  const target = document.getElementById(section);

  const tl = animations
    .timeline({
      scrollTrigger: {
        id: section,
        trigger: target,
        markers: markers,
        start: "top top",
        end: "+=800",
        scrub: true,
        invalidateOnRefresh: true,
      },
    })
    .to(cube.scale, {
      x: () => cube.scale.x - 2,
      y: () => cube.scale.y - 2,
      z: () => cube.scale.z - 2,
    });

  mm.add(`(min-width: ${BREAKPOINTS.sm}px)`, context => {
    tl.to(cube.rotation, {
      x: () => cube.rotation.x + Math.PI,
      ease: "power1.inOut",
    });
  });

  mm.add(`(max-width: ${BREAKPOINTS.sm - 1}px)`, context => {
    tl.to(cube.rotation, {
      y: () => cube.rotation.x + Math.PI,
      ease: "power1.inOut",
    });
  });

  tl.to(cube.scale, {
    x: () => cube.scale.x + 2,
    y: () => cube.scale.y + 2,
    z: () => cube.scale.z + 2,
  });
  return tl;
};

const cubeAnimations = ({ cube, scene }) => {
  const masterTl = animations.timeline();
  const mm = animations.matchMedia();
  const markers = false;

  const introductionTl = cubeIntroductionAnimation({
    cube,
    scene,
    mm,
    markers,
  });

  const articlesTl = cubeArticlesAnimation({ cube, mm, markers });

  const productsTl = cubeProductsAnimations({ cube, mm, markers });

  const streamTl = cubeStreamAnimations({ cube, mm, markers });

  masterTl
    .add(introductionTl)
    .add(articlesTl, "+=0.15")
    .add(productsTl, "+=0.5")
    .add(streamTl, "+=0.5");
};

export { cubeAnimations };
